/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'
import TysiaNotificationBadge from 'DesignSystem/TysiaNotificationBadge/index'
import Tysiav2Notepad from 'DesignSystem/Svgs/Tysiav2Notepad/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/NotesTab/Content",
  isSelected,
  colorActive,
  isHovered
  
}) {
let tabTabValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'tab',
})
let constantData = 'notes'
let aggregateData = fromAggregate.equals(tabTabValueData, constantData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSelected,
  colorActive,
  isHovered
  
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let colorActiveOrdtColorsGreen700 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7001 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7002 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7003 = colorActive ?? dtColorsGreen700
let notesCountCountValueData = fromData.useDataValue({ viewPath,
context: 'notes_count',
path: 'count',
})
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 paddingRight={dtSpaceXxs}
 text="Notes"
 onClick={onClick}
 data="tab.tab"
 data="'notes'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 marginTop={dtSpaceXs}
 size="normal"
 color={dtColorsNeutral900}
>
{childProps => (
<Tysiav2Notepad
{...childProps}
  viewPath={`${viewPath}/Tysiav2Notepad`}
 height={12}
 width={12}
 fill2={childProps.isSelected ? colorActiveOrdtColorsGreen7003 : childProps.isHovered ? colorActiveOrdtColorsGreen7002 : dtColorsNeutral400}
/>
)}
</SubMenuTab>
<TysiaNotificationBadge
  viewPath={`${viewPath}/TysiaNotificationBadge`}
 marginRight={dtSpaceL}
 backgroundColor={dtColorsNeutral300}
 color={dtColorsNeutral900}
 data="notes_count.count"
 text={notesCountCountValueData}
/>
</div>
{children}
</React.Fragment>)
}